import _ from 'lodash';
import pageTrackingConfig from '../config/pageTracking';
import gallupTracking from './gallupPageTracking.js';
//import comScoreTracking from './comScorePageTracking.js';
import googleAnalyticsTracking from './googleAnalyticsTracking.js';
//import sifoTracking from './sifoPageTracking.js';

export default function pageTracking(country, infiniteScroll) {
  // Don't track /embed page
  if (_.startsWith(window.location.pathname, '/embed')) return;

  const trackingSettings = pageTrackingConfig[country];

  _.map(trackingSettings, (trackingSetting, key) => {
    switch (key) {
    // Only track the first article in the inf. scroll for Gallup.
    //case 'gallup':
      //if (!infiniteScroll) gallupTracking(trackingSetting.siteId);
      //return;
    //case 'comScore':
      //comScoreTracking();
      //return;
    case 'googleAnalytics':
      googleAnalyticsTracking('page');
      return;
    //case 'sifo':
      //sifoTracking();
      //return;
    default:
      return;
    }
  });
}



// WEBPACK FOOTER //
// ./src/util/pageTracking.js